import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { SessionUserSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { AllSiteUsersSpace, AllSiteUsersSpaceDispatchProps, AllSiteUsersSpaceOwnProps, AllSiteUsersSpaceStateProps } from './AllSiteUsersSpace';

const mapStateToProps: MapStateToProps<AllSiteUsersSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  isSessionMultiSite: SessionUserSelectors.isSessionMultiSite(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
});

const mapDispatchToProps: MapDispatchToProps<AllSiteUsersSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
}, dispatch);

export const ConnectedAllSiteUsersSpace: React.ComponentClass<AllSiteUsersSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSiteUsersSpace);
